var React = require('react');

function Exit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M335.469 342.802l21.863 21.864L474 246 357.332 127.333l-21.863 21.865 79.469 81.469H200v30.666h213.864z","id":"path2","key":0}),React.createElement("path",{"d":"M116.707 2.962h276.668c23.468 0 42.666 19.198 42.666 42.666v93.334h-26.666V29.63H100.707v434.668h308.668V350.962h26.666v97.334c0 23.468-19.198 42.666-42.666 42.666H116.707c-23.468 0-42.666-19.198-42.666-42.666V45.628c0-23.468 19.198-42.666 42.666-42.666z","id":"path2-6","key":1})]);
}

Exit.displayName = "Exit";

Exit.defaultProps = {"viewBox":"0 0 512 512","id":"svg4"};

module.exports = Exit;

Exit.default = Exit;
